"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const utils_1 = require("@osmosys/utils");
const react_1 = tslib_1.__importDefault(require("react"));
const react_if_1 = require("react-if");
const react_loops_1 = require("react-loops");
const reactstrap_1 = require("reactstrap");
const ResourceList_1 = require("./ResourceList");
function ResourceListTable(_a) {
    var { icon, cells, headers, filters, plural, singular } = _a, props = tslib_1.__rest(_a, ["icon", "cells", "headers", "filters", "plural", "singular"]);
    return (react_1.default.createElement(ResourceList_1.ResourceList, Object.assign({}, props),
        react_1.default.createElement(ResourceList_1.ResourceList.SuccessState, null,
            icon && (react_1.default.createElement(reactstrap_1.Row, { className: "my-4" },
                react_1.default.createElement(ResourceList_1.ResourceList.Count, null, count => Array.from({ length: count }).map((a, i) => (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { key: `icon-${i}`, icon: icon, className: "m-1" })))))),
            react_1.default.createElement(reactstrap_1.Row, { className: "my-4" },
                react_1.default.createElement(reactstrap_1.Col, { className: "col-auto" },
                    react_1.default.createElement("div", { className: "d-block" },
                        react_1.default.createElement(ResourceList_1.ResourceList.NonEmptyState, null,
                            react_1.default.createElement("p", { className: "lead mb-0" },
                                react_1.default.createElement(ResourceList_1.ResourceList.Count, null, count => `${count} ${count === 1 ? singular : plural}`))),
                        react_1.default.createElement(ResourceList_1.ResourceList.EmptyState, null,
                            react_1.default.createElement("p", { className: "lead mb-0" },
                                "No ",
                                plural,
                                " found")))),
                filters && (react_1.default.createElement(reactstrap_1.Col, { className: "d-flex flex-grow-1 justify-content-end" },
                    react_1.default.createElement(reactstrap_1.Form, { inline: true }, filters)))),
            react_1.default.createElement(reactstrap_1.Table, { style: { tableLayout: 'fixed' } },
                react_1.default.createElement(react_if_1.When, { condition: !!headers },
                    react_1.default.createElement(ResourceList_1.ResourceList.TableHeader, { cells: headers })),
                react_1.default.createElement("tbody", null,
                    react_1.default.createElement(ResourceList_1.ResourceList.Detail, null, ({ data }) => {
                        const d = data;
                        if (cells) {
                            const renderedCells = cells(d);
                            if (headers && renderedCells.length !== headers.length) {
                                utils_1.logger.warn(`There are ${headers.length} headers and ${renderedCells.length} cells.`);
                            }
                            return (react_1.default.createElement("tr", { key: data.id },
                                react_1.default.createElement(react_loops_1.For, { of: renderedCells }, (cell, { index }) => {
                                    return react_1.default.createElement("td", { key: index }, cell);
                                })));
                        }
                        return null;
                    }))),
            react_1.default.createElement(ResourceList_1.ResourceList.Pagination, null))));
}
exports.ResourceListTable = ResourceListTable;
//# sourceMappingURL=ResourceListTable.js.map